"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

/* eslint-disable */
var _default = /*#__PURE__*/React.createElement("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 14 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  style: {
    display: 'inline-block',
    width: '1em',
    height: '1em',
    verticalAlign: 'middle',
    userSelect: 'none'
  }
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.4986 6.40788H4.78157C4.50467 6.40788 4.28021 6.7163 4.28021 7.09678C4.28021 7.47726 4.50467 7.78568 4.78157 7.78568H13.4986C13.7755 7.78568 14 7.47726 14 7.09678C14 6.7163 13.7755 6.40788 13.4986 6.40788Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.4986 1.2411H4.78157C4.50467 1.2411 4.28021 1.54953 4.28021 1.93001C4.28021 2.31049 4.50467 2.61891 4.78157 2.61891H13.4986C13.7755 2.61891 14 2.31049 14 1.93001C14 1.54953 13.7755 1.2411 13.4986 1.2411Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.4986 11.5746H4.78157C4.50467 11.5746 4.28021 11.8831 4.28021 12.2635C4.28021 12.644 4.50467 12.9524 4.78157 12.9524H13.4986C13.7755 12.9524 14 12.644 14 12.2635C14 11.8831 13.7755 11.5746 13.4986 11.5746Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.209994 3.502H1.09799V0.76L0.149994 0.868V0.34L1.69799 0.16V3.502H2.42999V4H0.209994V3.502Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.329994 8.49C0.329994 8.158 0.369994 7.91 0.449994 7.746C0.529994 7.578 0.697994 7.42 0.953994 7.272C1.20999 7.124 1.65799 6.918 2.29799 6.654V5.712C2.18199 5.684 1.99399 5.67 1.73399 5.67C1.32999 5.67 0.917994 5.708 0.497994 5.784L0.419994 5.316C0.767994 5.212 1.17999 5.16 1.65599 5.16C2.09999 5.16 2.42399 5.238 2.62799 5.394C2.83599 5.546 2.93999 5.786 2.93999 6.114C2.93999 6.386 2.89599 6.598 2.80799 6.75C2.71999 6.902 2.53999 7.052 2.26799 7.2C1.99999 7.348 1.54399 7.556 0.899994 7.824V8.502H2.87399V9H0.329994V8.49Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.33199 14.09C0.875994 14.09 0.491994 14.038 0.179994 13.934L0.251994 13.466C0.415994 13.502 0.601994 13.53 0.809994 13.55C1.01799 13.57 1.21799 13.58 1.40999 13.58C1.73399 13.58 1.95199 13.566 2.06399 13.538V12.392L1.01999 12.26V11.942L2.06399 11.774V10.712C1.95599 10.684 1.77999 10.67 1.53599 10.67C1.34399 10.67 1.14399 10.68 0.935994 10.7C0.727994 10.72 0.541994 10.748 0.377994 10.784L0.311994 10.316C0.635994 10.212 1.03599 10.16 1.51199 10.16C2.30799 10.16 2.70599 10.498 2.70599 11.174C2.70599 11.382 2.66399 11.566 2.57999 11.726C2.49999 11.886 2.38599 12.006 2.23799 12.086V12.116C2.39799 12.204 2.51599 12.322 2.59199 12.47C2.66799 12.614 2.70599 12.798 2.70599 13.022C2.70599 13.29 2.66199 13.502 2.57399 13.658C2.48599 13.81 2.34199 13.92 2.14199 13.988C1.94599 14.056 1.67599 14.09 1.33199 14.09Z",
  fill: "black"
}));

exports["default"] = _default;
//# sourceMappingURL=orderedList.js.map